export const getCashflowCoverageData = (benefitPayments, yearAssetsRunOut, assetXSReturn, view) => {
  const tolerance = 1e-6;

  return {
    benefitPayments: benefitPayments.map(x => ({ Year: x.Year, Amount: x[view] })),
    selectedYearAssetsRunOut: yearAssetsRunOut.filter(x => Math.abs(x.AssetXSReturn - assetXSReturn) < tolerance)[0],
    assetXSReturns: yearAssetsRunOut.map(x => x.AssetXSReturn),
    fundingLevel: yearAssetsRunOut.filter(x => Math.abs(x.AssetXSReturn - assetXSReturn) < tolerance)[0]['Funding Level'],
  }
}

export const getInitialAssetXSReturn = yearAssetsRunOut => {
  const numAssetXSReturns = yearAssetsRunOut.length;
  return yearAssetsRunOut.sort((a, b) => a.AssetXSReturn - b.AssetXSReturn)[Math.floor(numAssetXSReturns / 2)].AssetXSReturn;
}



// WEBPACK FOOTER //
// ./src/dashboards/CashflowCoverage/selectors.js